import {inject} from "@angular/core";
import {Router, ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable, of, EMPTY} from "rxjs";
import {mergeMap, take} from "rxjs/operators";
import {LANDING_ROUTE, ORGANISER_DASHBOARD} from "src/app/app-routing.module";
import {ApplicationFormSettings} from "@model";
import {ApplicationFormSettingsService} from "@services";

export const ApplicationFormSettingsListResolver: ResolveFn<Observable<ApplicationFormSettings[] | null> |
  Promise<ApplicationFormSettings[] | null> | ApplicationFormSettings[] | null> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   applicationFromSettingsService: ApplicationFormSettingsService = inject(ApplicationFormSettingsService),
   router: Router = inject(Router)): Observable<ApplicationFormSettings[] | null> |
    Promise<ApplicationFormSettings[] | null> | ApplicationFormSettings[] | null => {
    let eventId = route.queryParams["eventId"];
    if (!eventId) {
      router.navigate(!!route.data["protected"] ? [ORGANISER_DASHBOARD] : [LANDING_ROUTE]);
      return EMPTY;
    } else {
      return applicationFromSettingsService.fetchApplicationFormSettingsByEventId(
        +eventId, true)
        .pipe(
          take(1),
          mergeMap((res: ApplicationFormSettings[] | null) => {
            return of(res);
          })
        );
    }
  }
